<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Suivi Pta</h1>
      <div>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'dashboard' }">Tableau de bord</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            <router-link :to="{ name: 'classeurs' }">Suivi Pta</router-link>
          </li>
        </ol>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h3 class="card-title fw-bold mb-0">Suivi Pta </h3>
            <div class="card-options">
              <div class="btn-group">
                <div class="d-flex gap-2">
                  <button class="btn btn-primary btn-sm" >
                    <i class="fe fe-file-text me-1"></i> Afficher Detail
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="chart-container" style="position: relative; height: 400px;">
              <bar-chart :chart-data="chartData" :options="chartOptions" />
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>


  import { Bar } from 'vue-chartjs'


  export default {
    name: "SuiviPta",
    components: {
      BarChart: {
        extends: Bar,
        props: ['chartData', 'options'],
        mounted () {
          this.renderChart(this.chartData, this.options)
        }
      }
    },
    data() {
      return {
        chartData: {
          labels: ['January', 'February', 'March'],
          datasets: [
            {
              label: 'Données de suivi',
              backgroundColor: '#42A5F5',
              borderColor: '#1E88E5',
              borderWidth: 1,
              data: [40, 20, 12]
            }
          ]
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: true
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }



      }
    },
    mounted() {
    },
    computed: {
    },
    methods : {
    },
    created() {



    },
  }
</script>
